import request from '@/utils/request'

export function list(data) {
    return request({
        module: 'center',
        url: '/hostInfo/list',
        method: 'post',
        data: data
    })
}

export function edit(id) {
    return request({
        module: 'center',
        url: '/hostInfo/' + id,
        method: 'get'
    })
}

export function save(data) {
    return request({
        module: 'center',
        url: '/hostInfo/save',
        method: 'post',
        data: data
    })
}

export function del(data) {
    return request({
        module: 'center',
        url: '/hostInfo/delete',
        method: 'post',
        data: data
    })
}

export function editServer(data) {
    return request({
        module: 'center',
        url: '/hostInfo/editServer',
        method: 'post',
        data: data
    })
}

export function selectProductTypeSpread(data) {
    return request({
        module: 'center',
        url: '/hostInfo/selectProductTypeSpread',
        method: 'post',
        data: data
    })
}

export function selectInsertDevice() {
    return request({
        module: 'center',
        url: '/hostInfo/selectInsertDevice',
        method: 'post'
    })
}

export function selectArrangeAreaNumber() {
    return request({
        module: 'center',
        url: '/hostInfo/selectArrangeAreaNumber',
        method: 'post'
    })
}

export function selectProductArrange() {
    return request({
        module: 'center',
        url: '/hostInfo/selectProductArrange',
        method: 'post'
    })
}

export function selectAllYears() {
    return request({
        module: 'center',
        url: '/hostInfo/selectAllYears',
        method: 'post'
    })
}

export function selectReverseNumbers() {
    return request({
        module: 'center',
        url: '/hostInfo/selectReverseNumbers',
        method: 'post'
    })
}

export function selectTodayReverseExceptionNumber() {
    return request({
        module: 'center',
        url: '/hostInfo/selectTodayReverseExceptionNumber',
        method: 'post'
    })
}

export function selectReverseYears() {
    return request({
        module: 'center',
        url: '/hostInfo/selectReverseYears',
        method: 'post'
    })
}

export function selectTotalTurnover() {
    return request({
        module: 'center',
        url: '/hostInfo/selectTotalTurnover',
        method: 'post'
    })
}

export function selectDealEventNumber() {
    return request({
        module: 'center',
        url: '/hostInfo/selectDealEventNumber',
        method: 'post'
    })
}

export function selectInsertCourt() {
    return request({
        module: 'center',
        url: '/hostInfo/selectInsertCourt',
        method: 'post'
    })
}

export function selectdeployedDevicesTotalNumber() {
    return request({
        module: 'center',
        url: '/hostInfo/selectdeployedDevicesTotalNumber',
        method: 'post'
    })
}

export function getServerUrl(data) {
    return request({
        module: 'center',
        url: '/hostInfo/getServerUrl/' + data,
        method: 'get'
    })
}



// WEBPACK FOOTER //
// ./src/api/center/hostinfo.js